import { Component, EventEmitter, Input, Output } from '@angular/core';

type buttonColor = 'primary' | 'secondary' | 'terciary';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() text: string;
  @Input() defaultHeight = true;
  @Input() outline: boolean;
  @Input() shortPadding: boolean;
  @Input() contentOnly: boolean;
  @Input() fullWidth: boolean;
  @Input() reverse: boolean;
  @Input() color: buttonColor = 'primary';
  @Input() iconName: string;
  @Input() isLoading: boolean;
  @Input() disabled: boolean;
  @Input() autofocus = false;
  @Output() clickEvent = new EventEmitter();

  public emitClick(event) {
    event?.stopPropagation();
    if (!this.isLoading && !this.disabled) {
      this.clickEvent.emit();
    }
  }
}
